import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-bottom-navbar',
  standalone: true,
  imports: [RouterModule, TranslateModule],
  templateUrl: './bottom-navbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bottom-navbar.component.scss'],
})
export class BottomNavbarComponent {}
